import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import { endpoints } from "../endpoints";
import * as gatewayAndPriceListEmailActions from "../actions/gateway_and_price_list_email_actions";
import * as gatewayAndPriceListEmailTypes from "../types/gateway_and_price_list_email_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";

function* getListOfGatewayAndPriceEmail(action) {
  try {
    const res = yield call(api.get, endpoints.SUPER_ADMIN_GATEWAY_AND_PRICE_EMAIL, action.payload);
    if (res.status === 200) {
      yield put(gatewayAndPriceListEmailActions.getListOfGatewayAndPriceEmailSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(gatewayAndPriceListEmailActions.getListOfGatewayAndPriceEmailError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(gatewayAndPriceListEmailActions.getListOfGatewayAndPriceEmailError(e));
  }
}

export default function* gatewayAndPriceListEmailSaga() {
  yield takeLatest(gatewayAndPriceListEmailTypes.getListOfGatewayAndPriceEmail.GET_LIST_OF_GATEWAY_AND_PRICE_EMAIL_REQUEST, getListOfGatewayAndPriceEmail);
}
